import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

export interface ResponsiveBreakpoints {
  /** True for screen width <= theme.breakpoints.sm (<= 768px) */
  isMobile: boolean;
  /** True for screen width <= theme.breakpoints.md (<= 992px) */
  isTablet: boolean;
  /** True for screen width >= theme.breakpoints.lg (>= 1200px) */
  isDesktop: boolean;
}

/**
 * Provides boolean flags for common responsive breakpoints based on Mantine theme.
 * - isMobile: max-width: sm (768px)
 * - isTablet: max-width: md (992px)
 * - isDesktop: min-width: lg (1200px)
 */
export function useResponsiveBreakpoints(): ResponsiveBreakpoints {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`) ?? false;
  const isTablet = useMediaQuery(`(max-width: ${theme.breakpoints.md})`) ?? false;
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`) ?? false;

  return { isMobile, isTablet, isDesktop };
}
